import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchAsyncSearchUsers, resetSearch } from "./UserInfoSlice";
import "../../css/UserInfoSearch.css";

const UserInfoSearch: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState<string>("検索項目");
  const [searchWord, setSearchWord] = useState<string>("");
  const [isOpen, setIsOpen] = useState(false);

  const handleUserSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedOption !== "検索項目") {
      dispatch(
        fetchAsyncSearchUsers({
          option: selectedOption,
          word: searchWord,
          page: 1
        }) as any
      );
    }
  };

  const toggleSelect = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionSelect = (option: any) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  useEffect(() => {
    //アンマウント時にstoreをリセット
    return () => {
      dispatch(resetSearch());
    };
  }, [dispatch]);
  return (
    <form className="user_search_container" onSubmit={handleUserSearch}>
      <div className={`custom-select ${isOpen ? "open" : ""}`}>
        <div className="select-header" onClick={toggleSelect}>
          <span className="selected-option">{selectedOption}</span>
          <span className={`arrow ${isOpen ? "open" : ""}`}>&#9660;</span>
        </div>
        <ul className={`select-options ${isOpen ? "open" : ""}`}>
          <li
            className="select-option"
            onClick={() => {
              handleOptionSelect("メールアドレス");
              setIsOpen(false);
            }}>
            メールアドレス
          </li>
          <li
            className="select-option"
            onClick={() => {
              handleOptionSelect("電話番号");
              setIsOpen(false);
            }}>
            電話番号
          </li>
          <li
            className="select-option"
            onClick={() => {
              handleOptionSelect("生年月日");
              setIsOpen(false);
            }}>
            生年月日
          </li>
          <li
            className="select-option"
            onClick={() => {
              handleOptionSelect("ユーザNo.");
              setIsOpen(false);
            }}>
            ユーザNo.
          </li>
          <li
            className="select-option"
            onClick={() => {
              handleOptionSelect("氏名");
              setIsOpen(false);
            }}>
            氏名
          </li>
        </ul>
      </div>
      <div className="search-box">
        <input
          type="text"
          placeholder="検索ワード"
          className="search_input"
          value={searchWord}
          onChange={(e) => setSearchWord(e.target.value)}
        />
        <button type="submit" className="search_button">
          <i className="fas fa-search fa-fw"></i>
        </button>
      </div>
    </form>
  );
};

export default UserInfoSearch;
